import { render, staticRenderFns } from "./InstitutionAppointment.vue?vue&type=template&id=e027bb64"
import script from "./InstitutionAppointment.vue?vue&type=script&lang=js"
export * from "./InstitutionAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports